export interface ServiceCity {
  name: string
  county: string
  lat: number
  lng: number
  featured?: boolean
}

export const serviceCenter = {
  lat: 29.83,
  lng: -95.56,
  label: 'A&J Pool Plaster — Greater Houston',
  radiusMeters: 62000,
}

export const serviceCities: ServiceCity[] = [
  { name: 'Houston', county: 'Harris County', lat: 29.7604, lng: -95.3698, featured: true },
  { name: 'Katy', county: 'Harris / Fort Bend', lat: 29.7858, lng: -95.8245, featured: true },
  { name: 'Cypress', county: 'Harris County', lat: 29.9691, lng: -95.6972, featured: true },
  { name: 'Spring', county: 'Harris County', lat: 30.0799, lng: -95.4172 },
  { name: 'Tomball', county: 'Harris County', lat: 30.0972, lng: -95.6161 },
  { name: 'The Woodlands', county: 'Montgomery County', lat: 30.1658, lng: -95.4613 },
  { name: 'Humble', county: 'Harris County', lat: 29.9988, lng: -95.2622 },
  { name: 'Sugar Land', county: 'Fort Bend County', lat: 29.6197, lng: -95.6349, featured: true },
  { name: 'Missouri City', county: 'Fort Bend County', lat: 29.6186, lng: -95.5377 },
  { name: 'Richmond', county: 'Fort Bend County', lat: 29.5822, lng: -95.7607 },
  { name: 'Fulshear', county: 'Fort Bend County', lat: 29.6935, lng: -95.8913 },
  { name: 'Pearland', county: 'Brazoria County', lat: 29.5636, lng: -95.286 },
]
